import { render, staticRenderFns } from "./configureTheSurcharge.vue?vue&type=template&id=02e71686&scoped=true&"
import script from "./configureTheSurcharge.vue?vue&type=script&lang=js&"
export * from "./configureTheSurcharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e71686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02e71686')) {
      api.createRecord('02e71686', component.options)
    } else {
      api.reload('02e71686', component.options)
    }
    module.hot.accept("./configureTheSurcharge.vue?vue&type=template&id=02e71686&scoped=true&", function () {
      api.rerender('02e71686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/TariffTable/configureTheSurcharge.vue"
export default component.exports